import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Observable } from 'rxjs';

import { isDate, toISOStringPreserveTimeZone } from '@fcom/common-booking/utils/date-utils';

import { TooltipProps } from './tooltip';

@Component({
  selector: 'fin-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent {
  @Input()
  tooltip$: Observable<TooltipProps>;

  isDate = isDate;
  toISOStringPreserveTimeZone = toISOStringPreserveTimeZone;
}
